import { render, staticRenderFns } from "./DetailPackageRoomPlan.vue?vue&type=template&id=2bfea8e4&scoped=true"
import script from "./DetailPackageRoomPlan.vue?vue&type=script&lang=js"
export * from "./DetailPackageRoomPlan.vue?vue&type=script&lang=js"
import style0 from "./DetailPackageRoomPlan.vue?vue&type=style&index=0&id=2bfea8e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfea8e4",
  null
  
)

export default component.exports